module.exports = __webpack_public_path__ + "img/tab-water-alarm-selected.c52b8715.png";